import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterBar = ({ filters, onFilterChange, onSearch, onReset }) => {
  const industryOptions = [
    { value: 'all', label: 'All Industries' },
    { value: 'manufacturing', label: 'Manufacturing' },
    { value: 'it', label: 'Information Technology' },
    { value: 'healthcare', label: 'Healthcare' },
    { value: 'finance', label: 'Finance & Banking' },
    { value: 'retail', label: 'Retail & E-commerce' },
    { value: 'construction', label: 'Construction' },
    { value: 'logistics', label: 'Logistics & Supply Chain' }
  ];

  const serviceOptions = [
    { value: 'all', label: 'All Services' },
    { value: 'hr', label: 'HR Solutions' },
    { value: 'recruitment', label: 'Recruitment' },
    { value: 'trade', label: 'Global Trade' },
    { value: 'engineering', label: 'Engineering Services' },
    { value: 'consulting', label: 'Business Consulting' }
  ];

  const sizeOptions = [
    { value: 'all', label: 'All Project Sizes' },
    { value: 'small', label: 'Small (< 50 employees)' },
    { value: 'medium', label: 'Medium (50-200 employees)' },
    { value: 'large', label: 'Large (200-1000 employees)' },
    { value: 'enterprise', label: 'Enterprise (1000+ employees)' }
  ];

  const regionOptions = [
    { value: 'all', label: 'All Regions' },
    { value: 'north', label: 'North India' },
    { value: 'south', label: 'South India' },
    { value: 'east', label: 'East India' },
    { value: 'west', label: 'West India' },
    { value: 'international', label: 'International' }
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-sm space-y-4">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
        <h2 className="text-lg md:text-xl font-semibold text-foreground">Filter Success Stories</h2>
        <Button variant="ghost" size="sm" iconName="RotateCcw" iconPosition="left" onClick={onReset}>
          Reset Filters
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Industry"
          options={industryOptions}
          value={filters?.industry}
          onChange={(value) => onFilterChange('industry', value)}
          searchable
        />

        <Select
          label="Service Type"
          options={serviceOptions}
          value={filters?.service}
          onChange={(value) => onFilterChange('service', value)}
        />

        <Select
          label="Project Size"
          options={sizeOptions}
          value={filters?.size}
          onChange={(value) => onFilterChange('size', value)}
        />

        <Select
          label="Region"
          options={regionOptions}
          value={filters?.region}
          onChange={(value) => onFilterChange('region', value)}
        />
      </div>
      <Input
        type="search"
        placeholder="Search by company name, challenge, or solution..."
        value={filters?.search}
        onChange={(e) => onSearch(e?.target?.value)}
        className="w-full"
      />
    </div>
  );
};

export default FilterBar;